import { buildEntitiesFromWorkflowPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'
import { trackEntitiesGenerated } from '@/utils/helpHero'

export const generateEntitiesFromWorkflow = async ({
  workflow,
  cardTypes,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildEntitiesFromWorkflowPrompt({ workflow, cardTypes, stream })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })
    trackEntitiesGenerated(response)

    return response
  } else {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    trackEntitiesGenerated(response)

    return response || null
  }
}
